module.exports = __webpack_public_path__ + "static/media/bg_for_dost_for_ever.89b3a0ea.jpg";